import axios from 'axios'
import React from 'react'
import { useState } from 'react'
import { SchGap, SchInfo, SchLoading } from '../../shared/atoms'
import { SchContentContainer, SchTextInput } from '../../shared/molecules'
import { BACKEND_URL } from '../../utils'
import Wrapper from './style'

const LandClaim = () => {
	const [value, setValue] = useState('')
	const [loading, setLoading] = useState(false)
	const [emptyState, setEmptyState] = useState(false)
	// const [landId, setLandId] = useState(null)

	const [response, setResponse] = useState([])

	const onChangeInput = (e) => {
		const input = e.target.value.replace(/\D/g, "");
		setValue(input);
	}

	const onCheck = () => {
		if (value === '') {
			return
		} else {
			setLoading(true);
			setEmptyState(true);
			axios
				.get(`${BACKEND_URL}/api/check-land/${value}`)
				.then(res => {
					const result = res.data;

					setResponse(result);
					setLoading(false);
					// setLandId(value);
					setValue('')
				}).catch(err => {
					const error = err;
					console.log("error", error);
					setEmptyState(true);
				})
		}
	}

	const onKeyPressEnter = (e) => {
		if(e.key === "Enter") {
			onCheck();
		}
	}

	return (
		<Wrapper>
			<SchTextInput
				button
				onClick={onCheck}
				placeholder="Enter Scholarz ID [numeric]"
				value={value}
				onChange={onChangeInput}
				onKeyPress={onKeyPressEnter}
			/>
			<SchGap height={"calc(10px + 2vw)"}/>
			{emptyState &&
				<SchContentContainer>
					{loading
						? <SchLoading>Loading</SchLoading>
						:
						response.claimed ?
						<SchInfo
							text={`This land has been claimed`}
							type="warning"
						/>
						:
						<SchInfo
							text={`This land has not been claimed`}
							type="info"
						/>
					}
				</SchContentContainer>
			}
		</Wrapper>
	)
}

export default LandClaim
